import { QueryState } from 'redux-query';
import { useSelector } from 'react-redux';
import { ForceRequestCallback, useRequest } from 'redux-query-react';
import { PracticeInfo, State } from 'types';
import { getPracticeQuery } from './practiceQueries';
import { getPractice } from './practiceSelectors';

export const usePractice = (
  practiceId: number,
): [PracticeInfo | undefined, QueryState, ForceRequestCallback] => {
  const [queryState, refresh] = useRequest(getPracticeQuery(practiceId));
  const practice = useSelector((state: State) => getPractice(state, { practiceId }));
  return [practice, queryState, refresh];
};
